import React from "react";
import ReactDOM from "react-dom/client";
import "./app/css/index.css";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
 import { initApplicationAuth } from './app/auth/auth';
//import { initApplicationAuth } from "./app/mock";

const pca = initApplicationAuth();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    {/* <React.StrictMode> */}
    <MsalProvider instance={pca}>
      <App authProvider={pca} />
    </MsalProvider>
    {/* </React.StrictMode> */}
  </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
